import { PaymentCategories } from './payment'

export const PDCStatus = Object.freeze({
  OPEN: 'open',
  PROCESSED: 'processed',
  CLEARED: 'cleared',
  CANCELED: 'canceled',
  NOT_CLEARED: 'not_cleared',
  PENDING_APPROVAL: 'pending_approval'
})

export const PDCStatusText = Object.freeze({
  [PDCStatus.OPEN]: 'Open',
  [PDCStatus.PROCESSED]: 'Processed',
  [PDCStatus.CLEARED]: 'Cleared',
  [PDCStatus.CANCELED]: 'Canceled',
  [PDCStatus.NOT_CLEARED]: 'Not cleared',
  [PDCStatus.PENDING_APPROVAL]: 'Pending approval (create)'
})

export const PDCStatusSelect = [
  { text: 'Open', value: PDCStatus.OPEN },
  { text: 'Processed', value: PDCStatus.PROCESSED },
  { text: 'Cleared', value: PDCStatus.CLEARED },
  { text: 'Canceled', value: PDCStatus.CANCELED },
  { text: 'Not Cleared', value: PDCStatus.NOT_CLEARED },
  { text: 'Pending approval (create)', value: PDCStatus.PENDING_APPROVAL }
]
export function parsePDCStatus(raw) {
  return PDCStatusText[raw] || 'Unknown Status'
}

export const forbiddenCreatePDCCategories = [
  PaymentCategories.SECURITY_DEPOSIT,
  PaymentCategories.OVERPAYMENT,
  PaymentCategories.DOWN_PAYMENT
]
